import React, { useEffect, useState } from "react";
import "./navbar.css";
import AtomLogo from "../../assets/svgs/atom.svg";
import MishtyLogo from "../../assets/svgs/mishtybansallogo.svg";
import useWindowSize from "../../utils/hooks/useWindowSize";

function Navbar() {
  let arrOptions = [
    {
      id: "c2188c66-8660-404d-8444-192a2347d13f",
      title: "Github",
      link: "https://github.com/MishtyBansal",
    },
    {
      id: "4a93fbc5-0bf3-4cef-b02a-be26cb703215",
      title: "LinkedIn",
      link: "https://www.linkedin.com/in/mishtybansal/",
    },
    // { id: 'ff0591d5-2a63-4dee-baf9-c89cc0d06efc', title: 'About Me' },
    // { id: '1dc30709-75b7-4208-8edf-228cce31dcf3', title: 'Youtube Page' },
  ];
  const screenSize = useWindowSize();
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    const onScroll = () => {
      setOffset(window.pageYOffset);
      document.body.style.backgroundColor = "#200030";
    };

    // clean up code
    window.removeEventListener("scroll", onScroll);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className={`container-navbar ${offset > 30 && `after-scroll`}`}>
      <div className="inner-container">
        <img className="logo" src={MishtyLogo} alt="Logo" />
        {screenSize.width > 640
          ? arrOptions.map((element, index) => (
              <a key={index} href={element.link}>
                <h5
                  id={element.id}
                  style={{
                    paddingLeft: 40,
                    // color: index == 0 ? "white" : "#B6B5B6",
                    color: "#B6B5B6",
                    fontSize: 15,
                    fontWeight: 400,
                  }}
                >
                  {element.title}
                </h5>
              </a>
            ))
          : null}
      </div>
    </div>
  );
}

export default Navbar;
